import { useTranslation } from "react-i18next";

// Types
interface IFormErrorMessage {
  errorMessage: string;
}

// export
function FormErrorMessage({ errorMessage }: IFormErrorMessage) {
  const { t } = useTranslation();
  return (
    <div className="mg mt--10 mb-20">
      <span className="form-invalid">{t(errorMessage)}</span>
    </div>
  );
}

export default FormErrorMessage;
